import { GeneralLangFactory } from "../../core/lang";
import * as m from "../../core/model/model";

import BokioPlan = m.Entities.BokioPlan;

export const getPlanName = (plan: BokioPlan | undefined): string => {
	const generalLang = GeneralLangFactory();

	switch (plan) {
		case BokioPlan.FreeShared: // This shouldn't happen but we need to keep it for backwards compatibility
		case BokioPlan.Free:
		case BokioPlan.Beta:
			return generalLang.Free;
		case BokioPlan.Balance:
			return generalLang.BokioPlan_Name_Balance;
		case BokioPlan.Business:
			return generalLang.BokioPlan_Name_Business;
		case BokioPlan.Premium:
			return generalLang.BokioPlan_Name_Premium;
		case BokioPlan.Trial_2025:
			return generalLang.BokioPlan_Name_Trial;
		case BokioPlan.Pro:
			return generalLang.BokioPlan_Name_PremiumPlus;
		case BokioPlan.Basic_2025:
			return generalLang.BokioPlan_Name_Basic_2025;
		case BokioPlan.Premium_2025:
			return generalLang.BokioPlan_Name_Premium_2025;
		case BokioPlan.Business_2025:
			return generalLang.BokioPlan_Name_Business_2025;
		case BokioPlan.Plus_2025:
			return generalLang.BokioPlan_Name_Plus_2025;
		case undefined:
		case BokioPlan.Invalid:
		 	return "";
	}
};
